export default "__VITE_ASSET__87ee2cc6__"